// @ts-nocheck
/* eslint-disable padding-line-between-statements, import/order, react/jsx-newline, no-nested-ternary */
import React from 'react';

import {
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useIntl } from 'react-intl';

import { TextCell } from 'app/components/shared/table';
import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';

const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
  })
);

const FmSellingTable = ({ transactions, isLoading, convertToLocalTime }) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Table
      className={classes.table}
      size="small"
      aria-label="selling transactions Table"
    >
      <TableHead style={{ border: "0" }}>
        <TableRow style={{ border: "0" }}>
          <TableCell align="center">
            {intl.formatMessage({ id: 'transID' })}
          </TableCell>

          <TableCell align="center">
            {intl.formatMessage({ id: 'selling_price' })}
          </TableCell>

          <TableCell align="center">
            {intl.formatMessage({ id: 'init_balance' })}
          </TableCell>

          <TableCell align="center">
            {intl.formatMessage({ id: 'status' })}
          </TableCell>

          <TableCell align="center">
            {intl.formatMessage({ id: 'sold_date' })}
          </TableCell>

          <TableCell align="center">
            {intl.formatMessage({ id: 'Notes' })}
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {
          isLoading ? (
            <tr> <td colSpan={6} style={{ textAlign: "center", padding: "15px" }}>
          {intl.formatMessage({ id: 'loading' })}
            </td></tr>
          ) :
            transactions?.length > 0 ?
              transactions?.map((r, i) =>
                <TableRow key={r.id || i} className={classes.row}>
                  <TextCell
                    label={r.client_tx_id || '-'}
                    align="center"
                    style={{ fontFamily: 'Cairo', fontWeight: 600 }}
                  />

                  <TextCell
                    label={r.selling_price || '0'}
                    align="center"
                    style={{ fontFamily: 'Cairo', fontWeight: 600 }}
                  />

                  <TextCell
                    label={r.initial_wallet_credit || '0'}
                    align="center"
                    style={{ fontFamily: 'Cairo', fontWeight: 600 }}
                  />

                  <TextCell
                    label={r.state || '-'}
                    align="center"
                    style={{ fontFamily: 'Cairo', fontWeight: 600 }}
                  />

                  <TextCell
                    label={r.sold_at_utc ? convertToLocalTime(r.sold_at_utc) : '-'}
                    align="center"
                    style={{ fontFamily: 'Cairo', fontWeight: 600 }}
                  />

                  <TextCell
                    label={r.reverse_reason || '-'}
                    align="center"
                    style={{ fontFamily: 'Cairo', fontWeight: 600 }}
                  />
                </TableRow>
              )
              : <tr> <td colSpan={6} style={{ textAlign: "center", padding: "15px" }}>{intl.formatMessage({ id: 'NoDateAvailable' })}</td></tr>
        }
      </TableBody>
    </Table>
  )
};

export { FmSellingTable };
